import { render, staticRenderFns } from "./TiposServicioFiltradosTableSection.vue?vue&type=template&id=621630e3&scoped=true&"
import script from "./TiposServicioFiltradosTableSection.vue?vue&type=script&lang=js&"
export * from "./TiposServicioFiltradosTableSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621630e3",
  null
  
)

export default component.exports